import {
    Component,
    OnInit,
    Output,
    EventEmitter} from '@angular/core';

import { AccountService } from './../../service/accountService.service';
import { Status } from './../../service/status.service';
import { Locale } from './../../service/locale.service';
// import { AccountEntryesService } from './../../service/accountEntryesService.service';
import { InternalFunctionsRedirectService } from './../../service/internalFunctionsRedirectService.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent {

    @Output() switchContentInMain = new EventEmitter<string>();
    public menuSelectedItem = '';

    constructor(private accountService: AccountService,
                private status: Status,
                private locale: Locale,
                private IFRS: InternalFunctionsRedirectService) {

        this.menuSelectedItem = this.status.getLandingPage();
        this.IFRS.setSidebar(this);
    }

    public setMenuItem(value: string) {
        this.menuSelectedItem = value;
        this.switchContentInMain.emit(this.menuSelectedItem);
    }

    getSidebarStatus() { return this.status.getSidebarStatus(); }
}



// WEBPACK FOOTER //
// ./src/app/components/sidebar/sidebar.component.ts